import Select from 'react-select';
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { MdLocalPrintshop } from "react-icons/md";
import { FaSearch } from "react-icons/fa";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const Report = () => {

  const [noteType, setNoteType] = useState(null);
  const [issueDate, setIssueDate] = useState('');
  const [fetchData, setfetchData] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
const [stockFilter, setStockFilter] = useState('all');
  const [inventoryMap, setInventoryMap] = useState({});
  const [reconciliationWarnings, setReconciliationWarnings] = useState([]);
  const [selectedTech, setSelectedTech] = React.useState("");
  const [selectedGroup, setSelectedGroup] = useState("");
  

  const reportOptions = [
       { value: 'not_used', label: 'Issue But No Uasge ' },
    { value: 'employee_wise_material_issue', label: 'Employee Wise Material Issue ' },
    { value: 'stock_balance', label: 'Stock Balance' },
    { value: 'stock_min', label: 'Stock Below Minimum' },
     { value: 'stock_register', label: 'Stock Register' },
      { value: 'stock_register_sr', label: 'Stock Register Sr' },
    // { value: 'material_issue', label: 'Employee Issue' },
    // { value: 'material_receipt', label: 'Materail Receipt ' },
  
  ]


const fetchInventory = async () => {
    const res = await axios.get("https://api.skyguard.group/api/fetch-inventory");

    const map = {};
    res.data.result.forEach(item => {
      map[item.id] = item;
    });

    setInventoryMap(map);
    console.log(map);
  };

useEffect(() => {
  fetchInventory();
}, []);



const handleSearch = async (e) => {
  e.preventDefault();

  try {
    let result;

   
    if (noteType?.value === 'stock_balance') {
      result = await axios.get('https://api.skyguard.group/api/fetch-inventory');
      setfetchData(result.data.result || []);
      console.log('Stock Balance Data:', result.data.result);
    }

    // 🟢 STOCK MIN
    else if (noteType?.value === 'stock_min') {
      result = await axios.get('https://api.skyguard.group/api/fetch-inventory');
      setfetchData(result.data.result || []);
      console.log('Stock Min Data:', result.data.result);
    }

    // 🟢 OTHER REPORTS (INCLUDING material_issue)
    else {
      if (!fromDate || !toDate) {
        alert('Please select both From Date and To Date before searching.');
        return;
      }

      const params = new URLSearchParams();
      if (noteType?.value) params.append('note_type', noteType.value);
      if (fromDate) params.append('from_date', fromDate);
      if (toDate) params.append('to_date', toDate);

      result = await axios.get(
        `https://api.skyguard.group/api/get-report?${params.toString()}`
      );

      const data = result.data.result;

      console.log(data,'full api ')

 if (noteType?.value === "not_used") {
  const processed = getTechniciansWithNotUsedItems(
    data?.complaints || [],
    data?.materials || []
  );

  console.log("Issue but not used:", processed);
   setfetchData(processed);
  return;
}

if (noteType?.value === 'employee_wise_material_issue') {
  console.log("🔥 material_issue block running");

  console.log("API RAW:", result.data);
  console.log("API RESULT:", data);

  console.log("complaints:", data?.complaints);
  console.log("materials:", data?.materials);

  const processed = calculateTechnicianMaterial(
    data?.complaints || [],
    data?.materials || []
  );

  console.log('✅ processed:', processed);

  setfetchData(processed);
  return;
}



if (noteType?.value === "stock_register") {
  const params = new URLSearchParams();
  params.append("note_type", noteType.value);
  if (fromDate) params.append("from_date", fromDate);
  if (toDate) params.append("to_date", toDate);

  const result = await axios.get(
    `https://api.skyguard.group/api/get-report?${params.toString()}`
  );

   setReconciliationWarnings((result.data.result?.reconciliation || []).filter(item => item.flags.length));
   const stockData = calculateStockRegister(result.data.result);
  setfetchData(stockData);
  console.log("Stock Register Table:", stockData);
  return;
}


if (noteType?.value === "stock_register_sr") {
  const params = new URLSearchParams();
  params.append("note_type", noteType.value);
  if (fromDate) params.append("from_date", fromDate);
  if (toDate) params.append("to_date", toDate);

  const result = await axios.get(
    `https://api.skyguard.group/api/get-report?${params.toString()}`
  );

   setReconciliationWarnings((result.data.result?.reconciliation || []).filter(item => item.flags.length));
   const stockData = calculateStockRegisterSr(result.data.result);
  setfetchData(stockData);
  console.log("Stock Register Sr Table:", stockData);
  return;
}


      
      else if (Array.isArray(data)) {
    setfetchData(data);
  } else if (Array.isArray(data?.complaints)) {
    setfetchData(data.complaints);
  } else {
    setfetchData([]); // fallback safe
  }
    }

  } catch (error) {
    console.error('Error fetching report:', error);
  }
};
 


const handleExportExcel = () => {
  const table = document.getElementById("exportTable");

  if (!table) return;

  const worksheet = XLSX.utils.table_to_sheet(table);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Report");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const data = new Blob([excelBuffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  saveAs(data, "Report.xlsx");
};





const filteredStockData = Array.isArray(fetchData)
  ? fetchData.filter(item => {
      const stock = Number(item.stock);

      if (stockFilter === 'gt0') return stock > 0;
      if (stockFilter === 'lt0') return stock < 0;
      if (stockFilter === 'eq0') return stock === 0;
      if (stockFilter === 'neq0') return stock !== 0;

      return true; 
    })
  : [];


  useEffect(() => {
  setStockFilter('all');
}, [noteType]);


//final
// const calculateTechnicianMaterial = (complaints = [], materials = []) => {
//   const result = [];

//   // 🔹 STEP 1: Build issued map (tech + item)
//   const issuedMap = {};

//   materials.forEach(m => {
//     const techId = m.emp_id;
//     if (!techId || !m.items) return;

//     let items = [];
//     try {
//       items = typeof m.items === "string"
//         ? JSON.parse(m.items)
//         : m.items;
//     } catch (err) {
//       console.error("Invalid JSON in items:", m.items);
//     }

//     items.forEach(i => {
//       const itemId = i.id;
//       const issuedSR = Array.isArray(i.sr_no) ? i.sr_no : [];

//       const key = `${techId}_${itemId}`;

//       if (!issuedMap[key]) {
//         issuedMap[key] = {
//           totalSR: [],
//           balanceSR: []
//         };
//       }

//       issuedMap[key].totalSR.push(...issuedSR);
//       issuedMap[key].balanceSR.push(...issuedSR); // copy for running deduction
//     });
//   });

//   // 🔹 STEP 2: Sort complaints (IMPORTANT for correct running)
//   complaints.sort((a, b) => new Date(a.date) - new Date(b.date));

//   // 🔹 STEP 3: Process usage (running deduction)
//   complaints.forEach(call => {
//     (call.technicians || []).forEach(t => {
//       const techId = t.tech_db_id;
//       const techName = t.tech_name || t.emp_name || "Unknown";
//       if (!techId || !t.item_details) return;

//       let details = [];
//       try {
//         details = typeof t.item_details === "string"
//           ? JSON.parse(t.item_details)
//           : t.item_details;
//       } catch (err) {
//         console.error("Invalid JSON in item_details:", t.item_details);
//       }

//       details.forEach(d => {
//         const itemId = d.item_id || d.id;
//         const itemName = d.name || "Unknown";
//         const usedSR = Array.isArray(d.sr_no) ? d.sr_no : [];

//         const key = `${techId}_${itemId}`;
//         const issuedData = issuedMap[key] || { totalSR: [], balanceSR: [] };

//         // 🔥 Deduct used SR from balance
//         usedSR.forEach(sr => {
//           const index = issuedData.balanceSR.indexOf(sr);
//           if (index > -1) {
//             issuedData.balanceSR.splice(index, 1);
//           }
//         });

//         result.push({
//           tech_id: techId,
//           tech_name: techName,
//           item_id: itemId,
//           item_name: itemName,
//           cmp_id: call.id,              // ✅ added
//           branch: call.branch || "N/A", // ✅ added

//           issued_sr: issuedData.totalSR,
//           used_sr: usedSR,
//           pending_sr: [...issuedData.balanceSR],

//           issued_count: issuedData.totalSR.length,
//           used_count: usedSR.length,
//           pending_count: issuedData.balanceSR.length
//         });
//       });
//     });
//   });

//   return result;
// };


const calculateTechnicianMaterial = (complaints = [], materials = []) => {
  const result = [];

 
  const issuedMap = {}; // key = techId_itemId

  materials.forEach(m => {
    const techId = m.emp_id;
    if (!techId || !m.items) return;

    let items = [];
    try {
      items = typeof m.items === "string" ? JSON.parse(m.items) : m.items;
    } catch (err) {
      console.error("Invalid JSON in items:", m.items);
    }

    items.forEach(i => {
      const itemId = i.id;
      const issuedSR = Array.isArray(i.sr_no) ? i.sr_no : [];
      const itemName = i.name || "Unknown";

      const key = `${techId}_${itemId}`;

      if (!issuedMap[key]) {
        issuedMap[key] = {
          totalSR: [],
          balanceSR: [],
          materialInfo: {
            id: m.id,
            branch: m.branchId || "N/A",
            emp_name: m.emp_name || "Unknown",
             item_name: itemName
          }
        };
      }

      issuedMap[key].totalSR.push(...issuedSR);
      issuedMap[key].balanceSR.push(...issuedSR);
    });
  });

  // 🔹 STEP 2: Sort complaints by date
  complaints.sort((a, b) => new Date(a.date) - new Date(b.date));

  // 🔹 STEP 3: Process usage (running deduction)
  complaints.forEach(call => {
    (call.technicians || []).forEach(t => {
      const techId = t.tech_db_id;
      const techName = t.tech_name || t.emp_name || "Unknown";
      if (!techId || !t.item_details) return;

      let details = [];
      try {
        details = typeof t.item_details === "string"
          ? JSON.parse(t.item_details)
          : t.item_details;
      } catch (err) {
        console.error("Invalid JSON in item_details:", t.item_details);
      }

      details.forEach(d => {
        const itemId = d.item_id || d.id;
        const itemName = d.name || "Unknown";
        const usedSR = Array.isArray(d.sr_no) ? d.sr_no : [];

        const key = `${techId}_${itemId}`;
        const issuedData = issuedMap[key] || { totalSR: [], balanceSR: [], materialInfo: {} };

        // Deduct used SR from balance
        usedSR.forEach(sr => {
          const index = issuedData.balanceSR.indexOf(sr);
          if (index > -1) issuedData.balanceSR.splice(index, 1);
        });

        result.push({
          tech_id: techId,
          tech_name: techName,
          item_id: itemId,
          item_name: itemName,
          cmp_id: call.id,             
          branch: call.branch || "N/A", 

          issued_sr: issuedData.totalSR,
          used_sr: usedSR,
          pending_sr: [...issuedData.balanceSR],

          issued_count: issuedData.totalSR.length,
          used_count: usedSR.length,
          pending_count: issuedData.balanceSR.length
        });
      });
    });
  });

  
  Object.keys(issuedMap).forEach(key => {
    const [techId, itemId] = key.split("_");
    const alreadyUsed = result.some(
      r => r.tech_id == techId && r.item_id == itemId
    );
    if (!alreadyUsed) {
      const issuedData = issuedMap[key];
      result.push({
        tech_id: techId,
        tech_name: issuedData.materialInfo.emp_name || "Unknown",
        item_id: parseInt(itemId),
       item_name: issuedData.materialInfo.item_name || "Unknown",  
        cmp_id: issuedData.materialInfo.id,   
        branch: issuedData.materialInfo.branch,

        issued_sr: issuedData.totalSR,
        used_sr: [],
        pending_sr: [...issuedData.balanceSR],

        issued_count: issuedData.totalSR.length,
        used_count: 0,
        pending_count: issuedData.balanceSR.length
      });
    }
  });

  return result;
};


// 🔹 Function: Get technicians with issued items never used
// const getTechniciansWithNotUsedItems = (complaints = [], materials = []) => {
//   const result = [];

//   // Build issued map (tech + item)
//   const issuedMap = {}; // key = techId_itemId

//   materials.forEach(m => {
//     const techId = m.emp_id;
//     if (!techId || !m.items) return;

//     let items = [];
//     try {
//       items = typeof m.items === "string" ? JSON.parse(m.items) : m.items;
//     } catch (err) {
//       console.error("Invalid JSON in items:", m.items);
//     }

//     items.forEach(i => {
//       const itemId = i.id;
//       const itemName = i.name || "Unknown";
//       const issuedSR = Array.isArray(i.sr_no) ? i.sr_no : [];

//       const key = `${techId}_${itemId}`;
//       if (!issuedMap[key]) {
//         issuedMap[key] = {
//           totalSR: issuedSR.slice(),
//           balanceSR: issuedSR.slice(),
//           materialInfo: {
//             id: m.id,
//             branch: m.branchId || "N/A",
//             emp_name: m.emp_name || "Unknown",
//             item_name: itemName
//           }
//         };
//       } else {
//         issuedMap[key].totalSR.push(...issuedSR);
//         issuedMap[key].balanceSR.push(...issuedSR);
//       }
//     });
//   });

//   // Process complaints to deduct used SR
//   complaints.forEach(call => {
//     (call.technicians || []).forEach(t => {
//       const techId = t.tech_db_id;
//       if (!techId || !t.item_details) return;

//       let details = [];
//       try {
//         details = typeof t.item_details === "string" ? JSON.parse(t.item_details) : t.item_details;
//       } catch (err) {
//         console.error("Invalid JSON in item_details:", t.item_details);
//       }

//       details.forEach(d => {
//         const itemId = d.item_id || d.id;
//         const usedSR = Array.isArray(d.sr_no) ? d.sr_no : [];
//         const key = `${techId}_${itemId}`;

//         if (issuedMap[key]) {
//           usedSR.forEach(sr => {
//             const idx = issuedMap[key].balanceSR.indexOf(sr);
//             if (idx > -1) issuedMap[key].balanceSR.splice(idx, 1);
//           });
//         }
//       });
//     });
//   });

//   // Only include technicians/items with never used items
//   Object.keys(issuedMap).forEach(key => {
//     const [techId, itemId] = key.split("_");
//     const issuedData = issuedMap[key];

//     if (issuedData.balanceSR.length === issuedData.totalSR.length) {
//       // Means none of the issued SRs were ever used
//       result.push({
//         tech_id: parseInt(techId),
//         tech_name: issuedData.materialInfo.emp_name || "Unknown",
//         item_id: parseInt(itemId),
//         item_name: issuedData.materialInfo.item_name || "Unknown",
//         cmp_id: issuedData.materialInfo.id,
//         branch: issuedData.materialInfo.branch,

//         issued_sr: issuedData.totalSR,
//         used_sr: [],
//         pending_sr: issuedData.totalSR,

//         issued_count: issuedData.totalSR.length,
//         used_count: 0,
//         pending_count: issuedData.totalSR.length
//       });
//     }
//   });

//   return result;
// };


const getTechniciansWithNotUsedItems = (complaints = [], materials = []) => {
  const result = [];

  // Build issued map (tech + item)
  const issuedMap = {}; // key = techId_itemId

  materials.forEach(m => {
    const techId = m.emp_id;
    if (!techId || !m.items) return;

    let items = [];
    try {
      items = typeof m.items === "string" ? JSON.parse(m.items) : m.items;
    } catch (err) {
      console.error("Invalid JSON in items:", m.items);
    }

    items.forEach(i => {
      const itemId = i.id;
      const itemName = i.name || "Unknown";
      const issuedSR = Array.isArray(i.sr_no) ? i.sr_no : [];

      const key = `${techId}_${itemId}`;
      if (!issuedMap[key]) {
        issuedMap[key] = {
          totalSR: issuedSR.slice(),
          balanceSR: issuedSR.slice(),
          materialInfo: {
            min_id: m.id,                    // Material issue ID
            branch: m.branchId || "N/A",     // Branch of issue
            emp_name: m.emp_name || "Unknown",// Employee who was issued
            item_name: itemName,              // Item name
            issue_date: m.issue_date || null, // Date of material issue
            added_by: m.added_by || m.emp_name || "Unknown" // Who added the material
          }
        };
      } else {
        issuedMap[key].totalSR.push(...issuedSR);
        issuedMap[key].balanceSR.push(...issuedSR);
      }
    });
  });

  // Process complaints to deduct used SR
  complaints.forEach(call => {
    (call.technicians || []).forEach(t => {
      const techId = t.tech_db_id;
      if (!techId || !t.item_details) return;

      let details = [];
      try {
        details = typeof t.item_details === "string" ? JSON.parse(t.item_details) : t.item_details;
      } catch (err) {
        console.error("Invalid JSON in item_details:", t.item_details);
      }

      details.forEach(d => {
        const itemId = d.item_id || d.id;
        const usedSR = Array.isArray(d.sr_no) ? d.sr_no : [];
        const key = `${techId}_${itemId}`;

        if (issuedMap[key]) {
          usedSR.forEach(sr => {
            const idx = issuedMap[key].balanceSR.indexOf(sr);
            if (idx > -1) issuedMap[key].balanceSR.splice(idx, 1);
          });
        }
      });
    });
  });

  // Only include technicians/items with never used items
  Object.keys(issuedMap).forEach(key => {
    const [techId, itemId] = key.split("_");
    const issuedData = issuedMap[key];

    if (issuedData.balanceSR.length === issuedData.totalSR.length) {
      // None of the issued SRs were ever used
      const mInfo = issuedData.materialInfo;
      result.push({
        tech_id: parseInt(techId),
        tech_name: mInfo.emp_name || "Unknown",
        item_id: parseInt(itemId),
        item_name: mInfo.item_name || "Unknown",

        // Material issue info
        cmp_id: mInfo.min_id,       // MIN/id
        branch: mInfo.branch,       // Branch
        issue_date: mInfo.issue_date, // Issue date
        added_by: mInfo.added_by,     // Who added material

        issued_sr: issuedData.totalSR,
        used_sr: [],
        pending_sr: issuedData.totalSR,

        issued_count: issuedData.totalSR.length,
        used_count: 0,
        pending_count: issuedData.totalSR.length
      });
    }
  });

  return result;
};


const calculateStockRegister = ({ materials, returns, purchases, rows }) => {
  if (Array.isArray(rows)) return rows;
  // Step 1: Flatten all transactions into one array
  const transactions = [];

  // Material Issues (OUT)
  materials.forEach(m => {
    const items = JSON.parse(m.items);
    items.forEach(i => {
      transactions.push({
        type: 'Issue',
        date: m.issue_date,
        item_id: i.id,
        item_name: i.name,
        qty: -Number(i.qty), // negative because issue reduces stock
        rate: i.rate || 0,
        // ref_doc: m.ref_doc,
          ref_doc: `MIN/${m.id}/${m.branchId}`,
      });
    });
  });

  // Material Returns (IN)
  returns.forEach(r => {
    const items = JSON.parse(r.items);
    items.forEach(i => {
      transactions.push({
        type: 'Return',
        date: r.issue_date,
        item_id: i.id,
        item_name: i.name,
        qty: Number(i.qty),
        rate: i.rate || 0,
        // ref_doc: r.ref_doc,
              ref_doc: `MRN/${r.id}/${r.branchId}`,
      });
    });
  });

  // Purchases (IN)
  purchases.forEach(p => {
    const items = JSON.parse(p.items);
    items.forEach(i => {
      transactions.push({
        type: 'Purchase',
        date: p.date,
        item_id: i.id,
        item_name: i.name,
        qty: Number(i.qty),
        rate: Number(i.rate || 0),
        // ref_doc: p.ref_doc || p.id,
        ref_doc: `PU/${p.inv_no}/${p.branchId}`,
      });
    });
  });

  // Step 2: Sort by date ascending
  transactions.sort((a, b) => new Date(a.date) - new Date(b.date));

  // Step 3: Calculate running balance per item
  const balanceMap = {}; // item_id => current balance
  const finalReport = transactions.map(t => {
    if (!balanceMap[t.item_id]) balanceMap[t.item_id] = 0;
    balanceMap[t.item_id] += t.qty; // add qty (negative for issue)
    return {
      doc_type: t.type,
      date: t.date,
      item_name: t.item_name,
      item_id:t.item_id,
      qty_in: t.qty > 0 ? t.qty : 0,
      qty_out: t.qty < 0 ? -t.qty : 0,
      balance: balanceMap[t.item_id],
      rate: t.rate,
      ref_doc: t.ref_doc,
    };
  });

  return finalReport;
};

const calculateStockRegisterSr = ({ materials, returns, purchases, rows }) => {
  if (Array.isArray(rows)) return rows;
  // Step 1: Flatten all transactions into one array
  const transactions = [];

  // Material Issues (OUT)
  materials.forEach(m => {
    const items = JSON.parse(m.items);
    items.forEach(i => {
      transactions.push({
        type: 'Issue',
        date: m.issue_date,
        item_id: i.id,
        item_name: i.name,
        qty: -Number(i.qty), // negative because issue reduces stock
        rate: i.rate || 0,
        ref_doc: `MIN/${m.id}/${m.branchId}`,
        sr_no: i.sr_no || [], // include SR numbers for tracking
        added_by: m.added_by || m.emp_name || '', // track who issued
      });
    });
  });

  // Material Returns (IN)
  returns.forEach(r => {
    const items = JSON.parse(r.items);
    items.forEach(i => {
      transactions.push({
        type: 'Return',
        date: r.issue_date,
        item_id: i.id,
        item_name: i.name,
        qty: Number(i.qty),
        rate: i.rate || 0,
        ref_doc: `MRN/${r.id}/${r.branchId}`,
        sr_no: i.sr_no || [], // include SR numbers for tracking
        added_by: r.added_by || r.emp_name || '', // track who returned
      });
    });
  });

  // Purchases (IN) - no SR tracking needed, keep existing logic
  purchases.forEach(p => {
    const items = JSON.parse(p.items);
    items.forEach(i => {
      transactions.push({
        type: 'Purchase',
        date: p.date,
        item_id: i.id,
        item_name: i.name,
        qty: Number(i.qty),
        rate: Number(i.rate || 0),
        ref_doc: `PU/${p.inv_no}/${p.branchId}`,
      });
    });
  });

  // Step 2: Sort by date ascending
  transactions.sort((a, b) => new Date(a.date) - new Date(b.date));

  // Step 3: Calculate running balance per item & add SR No
  const balanceMap = {}; // item_id => current balance
  let srNoCounter = 1; // initialize serial number
  const finalReport = transactions.map(t => {
    if (!balanceMap[t.item_id]) balanceMap[t.item_id] = 0;
    balanceMap[t.item_id] += t.qty; // add qty (negative for issue)

    return {
      sr_no: srNoCounter++, // sequential serial number
      doc_type: t.type,
      date: t.date,
      item_name: t.item_name,
      item_id: t.item_id,
      qty_in: t.qty > 0 ? t.qty : 0,
      qty_out: t.qty < 0 ? -t.qty : 0,
      balance: balanceMap[t.item_id],
      rate: t.rate,
      ref_doc: t.ref_doc,
      sr_numbers: t.sr_no, // track SR numbers for issue/return
      added_by: t.added_by || '', // track who did the issue/return
    };
  });

  return finalReport;
};

  return (      
    <>

      <div className='main-section'>
        <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>

          <h3 className='my-3 fw-bold fs-5 golos'>Report</h3>
          {['stock_register', 'stock_register_sr'].includes(noteType?.value) && reconciliationWarnings.length > 0 && (
            <div className="alert alert-warning" role="status">
              {reconciliationWarnings.length} items need stock reconciliation. Register balances reflect documents; recorded stock and serial counts have not been adjusted.
            </div>
          )}


          <div className="row g-3 align-items-end">
            <div className="col-md-4">
              <label className='fw-bold'>Select Report</label>
              <Select
                options={reportOptions}
                placeholder="Choose Type ..."
                id="source"
                value={noteType}

                onChange={(selected) => {
                  setNoteType(selected);
                  setfetchData([]);
                }}
              />
            </div>

            <div className="col-md-4">
              <label className='fw-bold'>From Date</label>
              <input
                type="date"
                className="form-control"
                name="from_date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            <div className="col-md-4">
              <label className='fw-bold'>To Date</label>
              <input
                type="date"
                className="form-control"
                name="to_date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>


            <div className="col-md-12 d-flex justify-content-end align-items-end">
             

              <FaSearch size={26} className="ms-1 text-primary"
                style={{ cursor: "pointer" }}
                title="Search"
                onClick={handleSearch}
              />

              <MdLocalPrintshop
                size={26}
                className="ms-1 text-success"
                   onClick={handleExportExcel}
                style={{ cursor: "pointer" }}
                title="Print "
              />

            </div>
          </div>
          <div id="exportTable" className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>

{noteType?.value === 'stock_balance' && (
  <div className="mb-3">
    <select
      className="form-select w-auto"
      value={stockFilter}
      onChange={(e) => setStockFilter(e.target.value)}
    >
      <option value="all">All</option>
      <option value="gt0">Greater than 0</option>
      <option value="lt0">Less than 0</option>
      <option value="eq0">Equal to 0</option>
      <option value="neq0">Not equal to 0</option>
    </select>
  </div>
)}

{noteType?.value === 'employee_wise_material_issue' && (
  <div className="mb-3 d-flex gap-3">
    <div>
      <label className="form-label">Filter by Technician:</label>
      <select
        className="form-select"
        value={selectedTech}
        onChange={(e) => setSelectedTech(e.target.value)}
      >
        <option value="">All Technicians</option>
        {Array.from(new Set(fetchData.map(t => t.tech_name))).map((tech, idx) => (
          <option key={idx} value={tech}>{tech}</option>
        ))}
      </select>
    </div>

    <div>
      <label className="form-label">Filter by Item Group:</label>
      <select
        className="form-select"
        value={selectedGroup}
        onChange={(e) => setSelectedGroup(e.target.value)}
      >
        <option value="">All Groups</option>
        {Array.from(new Set(fetchData.map(t => inventoryMap[t.item_id]?.group_item || "No Category"))).map((group, idx) => (
          <option key={idx} value={group}>{group}</option>
        ))}
      </select>
    </div>
  </div>
)}

{noteType?.value === 'not_used' && (
  <div className="mb-3 d-flex gap-3 align-items-center">
    {/* Technician Filter */}
    <div>
      <label className="form-label">Filter by Technician:</label>
      <select
        className="form-select w-auto"
        value={selectedTech}
        onChange={(e) => setSelectedTech(e.target.value)}
      >
        <option value="">All Technicians</option>
        {Array.from(new Set(fetchData.map(t => t.tech_name))).map((tech, idx) => (
          <option key={idx} value={tech}>{tech}</option>
        ))}
      </select>
    </div>

    {/* Item Group Filter */}
    <div>
      <label className="form-label">Filter by Item Group:</label>
      <select
        className="form-select w-auto"
        value={selectedGroup}
        onChange={(e) => setSelectedGroup(e.target.value)}
      >
        <option value="">All Groups</option>
        {Array.from(new Set(fetchData.map(t => inventoryMap[t.item_id]?.group_item || "No Category"))).map((group, idx) => (
          <option key={idx} value={group}>{group}</option>
        ))}
      </select>
    </div>
  </div>
)}


{noteType?.value === 'stock_register' && (
  <div className="mb-3 d-flex gap-3 align-items-center">
    <label className="form-label mb-0">Filter by Item Group:</label>
    <select
      className="form-select w-auto"
      value={selectedGroup}
      onChange={(e) => setSelectedGroup(e.target.value)}
    >
      <option value="">All Groups</option>
      {Array.from(
        new Set(fetchData.map(t => inventoryMap[t.item_id]?.group_item || "No Category"))
      ).map((group, idx) => (
        <option key={idx} value={group}>{group}</option>
      ))}
    </select>
  </div>
)}

{noteType?.value === 'stock_register_sr' && (
  <div className="mb-3 d-flex gap-3 align-items-center">
    <label className="form-label mb-0">Filter by Item Group:</label>
    <select
      className="form-select w-auto"
      value={selectedGroup}
      onChange={(e) => setSelectedGroup(e.target.value)}
    >
      <option value="">All Groups</option>
      {Array.from(
        new Set(fetchData.map(t => inventoryMap[t.item_id]?.group_item || "No Category"))
      ).map((group, idx) => (
        <option key={idx} value={group}>{group}</option>
      ))}
    </select>
  </div>
)}



            {noteType?.value === 'stock_balance' ? (
              // 🟢 STOCK BALANCE TABLE
              <table className="table table-bordered table-striped table-hover text-center align-middle">
                <thead className='table-info' >
                  <tr>
                    <th>Sr No</th>
                    <th>Item Name</th>
                    <th>Stock</th>
                  </tr>
                </thead>
               

                <tbody>
  {filteredStockData.length > 0 ? (
    filteredStockData.map((item, idx) => (
      <tr key={idx}>
        <td>{idx + 1}</td>
        <td>{item.name}</td>
        <td>{item.stock}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="3">No stock data found</td>
    </tr>
  )}
</tbody>
              </table>
            ) : noteType?.value === 'stock_min' ? (
              // 🟡 STOCK MIN TABLE
              <table className="table table-bordered table-striped table-hover text-center align-middle">
                <thead className='table-info' >
                  <tr>
                    <th>Sr No</th>
                    <th>Item Name</th>
                    <th>Available</th>
                    <th>Min Stock</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(fetchData) && fetchData.length > 0 ? (
                    fetchData.map((item, idx) => (
                      <tr key={idx}>
                        <td>{idx + 1}</td>
                        <td>{item.name}</td>
                        <td>{item.stock}</td>
                        <td>{item.min_stock}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4">No stock min data found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            ) : noteType?.value === 'stock_register' ? (
  <>


    <table className="table table-bordered table-striped table-hover text-center align-middle">
      <thead className='table-info'>
        <tr>
          <th>Sr No</th>
          <th>Document Type</th>
          <th>Date</th>
          <th>Item Name (Group)</th>
          <th>Qty In</th>
          <th>Qty Out</th>
          <th>Balance</th>
          <th>Rate</th>
          <th>Ref Doc</th>
        </tr>
      </thead>
      <tbody>
        {Array.isArray(fetchData) && fetchData.length > 0 ? (
          fetchData
            .filter(item => !selectedGroup || (inventoryMap[item.item_id]?.group_item || "No Category") === selectedGroup)
            .map((item, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{item.doc_type}</td>
                <td>{new Date(item.date).toLocaleDateString()}</td>
                <td>{item.item_name} ({inventoryMap[item.item_id]?.group_item || "No Group"})   </td>
                <td>{item.qty_in}</td>
                <td>{item.qty_out}</td>
                <td>{item.balance === null ? 'Unknown' : item.balance}</td>
                <td>{item.rate}</td>
                <td>{item.ref_doc}</td>
              </tr>
            ))
        ) : (
          <tr>
            <td colSpan="9">No stock register data found</td>
          </tr>
        )}
      </tbody>
    </table>
  </>
) 
     

: noteType?.value === 'stock_register_sr' ? (
  <>


    <table className="table table-bordered table-striped table-hover text-center align-middle">
      <thead className='table-info'>
        <tr>
          <th>Sr No</th>
          <th>Document Type</th>
          <th>Date</th>
          <th>Item Name (Group)</th>
          <th>Sr No</th>
          <th>Qty In</th>
          <th>Qty Out</th>
          <th>Balance</th>
          <th>Rate</th>
          <th>Ref Doc</th>
        </tr>
      </thead>
      <tbody>
        {Array.isArray(fetchData) && fetchData.length > 0 ? (
          fetchData
            .filter(item => !selectedGroup || (inventoryMap[item.item_id]?.group_item || "No Category") === selectedGroup)
            .map((item, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{item.doc_type}</td>
                <td>{new Date(item.date).toLocaleDateString()}</td>
                <td>{item.item_name} ({inventoryMap[item.item_id]?.group_item || "No Group"})   </td>
            <td>{item.sr_numbers?.join(', ') || '-'}</td>
                <td>{item.qty_in}</td>
                <td>{item.qty_out}</td>
                <td>{item.balance === null ? 'Unknown' : item.balance}</td>
                <td>{item.rate}</td>
                <td>{item.ref_doc}</td>
              </tr>
            ))
        ) : (
          <tr>
            <td colSpan="9">No stock register data found</td>
          </tr>
        )}
      </tbody>
    </table>
  </>
) 
            
            
            : noteType?.value === 'employee_wise_material_issue' ? (
 
  <table className="table table-bordered table-striped table-hover text-center align-middle">
    <thead className='table-info'>
      <tr>
        <th>Sr No</th>
        <th>Technician</th>
        <th>Item (Group)</th>
        <th>Ref Doc</th>
        <th>Issued SR</th>
        <th>Used SR</th>
        <th>Unused SR</th>
        <th>Issued/Return</th>
        <th>Used</th>
        <th>Unused</th>
      </tr>
    </thead>

    {/* <tbody>
      {Array.isArray(fetchData) && fetchData.length > 0 ? (
        fetchData.map((t, idx) => (
          <tr key={idx}>
            <td>{idx + 1}</td>
            <td>{t.tech_name || "N/A"}</td>
            <td>{t.item_name} ({inventoryMap[t.item_id]?.group_item || "No Category"}) </td>
       

          <td>
  {t.used_count > 0
    ? `CMP/${t.cmp_id}/${t.branch || "N/A"}` 
    : `MIN/${t.cmp_id}/${t.branch || "N/A"}` 
  }
</td>

            <td>{t.issued_sr?.join(", ") || "-"}</td>
            <td>{t.used_sr?.join(", ") || "-"}</td>
            <td>{t.pending_sr?.join(", ") || "-"}</td>

            <td>{t.issued_count}</td>
            <td>{t.used_count}</td>
            <td>{t.pending_count}</td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="10">No data found</td>
        </tr>
      )}
    </tbody> */}

<tbody>
  {Array.isArray(fetchData) && fetchData.length > 0 ? (
    fetchData
      .filter(t => !selectedTech || t.tech_name === selectedTech)
      .filter(t => !selectedGroup || (inventoryMap[t.item_id]?.group_item || "No Category") === selectedGroup)
      .map((t, idx) => (
        <tr key={idx}>
          <td>{idx + 1}</td>
          <td>{t.tech_name || "N/A"}</td>
          <td>{t.item_name} ({inventoryMap[t.item_id]?.group_item || "No Category"})</td>
          <td>{t.used_count > 0 ? `CMP/${t.cmp_id}/${t.branch || "N/A"}` : `MIN/${t.cmp_id}/${t.branch || "N/A"}`}</td>
          <td>{t.issued_sr?.join(", ") || "-"}</td>
          <td>{t.used_sr?.join(", ") || "-"}</td>
          <td>{t.pending_sr?.join(", ") || "-"}</td>
          <td>{t.issued_count}</td>
          <td>{t.used_count}</td>
          <td>{t.pending_count}</td>
        </tr>
      ))
  ) : (
    <tr>
      <td colSpan="10">No data found</td>
    </tr>
  )}
</tbody>
  </table>

)   :noteType?.value === 'not_used' ? (
  <table className="table table-bordered table-striped table-hover text-center align-middle">
    <thead className='table-info'>
      <tr>
        <th>Sr No</th>
        <th>Technician</th>
        <th>Item (Group) </th>
        <th>Ref Doc</th>
        <th>Issued Qty</th>
        <th>Used Qty</th>
        <th>Unused Qty</th>
        <th>Used in Calls</th>
      </tr>
    </thead>
   <tbody>
  {Array.isArray(fetchData) && fetchData.length > 0 ? (
    fetchData
       .filter(t => (!selectedTech || t.tech_name === selectedTech) &&
               (!selectedGroup || (inventoryMap[t.item_id]?.group_item || "No Category") === selectedGroup))
      .map((t, idx) => (
        <tr key={idx}>
          <td>{idx + 1}</td>
          <td>{t.tech_name || "N/A"}</td>
          <td>{t.item_name} ({inventoryMap[t.item_id]?.group_item || "No Category"})</td>
          <td>{`MIN/${t.cmp_id}/${t.branch}`}</td>
          <td>{t.issued_count}</td>
          <td>{t.used_count}</td>
          <td>{t.pending_count}</td>
          <td>
            {t.used_in_calls && t.used_in_calls.length > 0
              ? t.used_in_calls.map(c => `CMP/${c.complaint_id}/${c.branch}`).join(", ")
              : "-"}
          </td>
        </tr>
      ))
  ) : (
    <tr>
      <td colSpan="7">No data found</td>
    </tr>
  )}
</tbody>
  </table>
) 
            
            
            : noteType?.value === 'material_issue' ? (
              // 🟡 STOCK MIN TABLE
              <table className="table table-bordered table-striped table-hover text-center align-middle">
                <thead className='table-info' >
                  <tr>
                    <th>Sr No</th>
                    <th>Employee Name</th>
                    <th>Issue Date</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(fetchData) && fetchData.length > 0 ? (
                    fetchData.map((employee, empIdx) => (
                      <tr key={empIdx}>
                        <td>{empIdx + 1}</td>
                        <td>{employee.emp_name}</td>
                        <td>
                          {new Date(employee.issue_date).toLocaleDateString()}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3">No issue data found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            ) : (
              // 🟠 MATERIAL ISSUE TABLE
              <table className="table table-bordered table-striped table-hover text-center align-middle">
                <thead className='table-info'>
                  <tr>
                    <th>Sr No</th>
                    <th>Employee Name</th>
                    <th>Issue Date</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(fetchData) && fetchData.length > 0 ? (
                    fetchData.map((employee, empIdx) => (
                      <tr key={empIdx}>
                        <td>{empIdx + 1}</td>
                        <td>{employee.emp_name}</td>
                        <td>
                          {new Date(employee.issue_date).toLocaleDateString()}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3">No issue data found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}



          </div>

        </div>
      </div>
    </>
  )
}

export default Report
